<template>

  <section>
    <div class="img">
      <div>
        <img src="../assets/urgentnotice.jpg" style="width: 100%;height: 100%;" />
      </div>
    </div>

    <div style="margin-left: 10px;" v-if="isMe == true">
      <Progress :percent="progress" :stroke-width="20" status="active" :stroke-color="['#FFFFFF','#00391E']"
        style="width: 100%;"><span style="color: #00391E;">{{progressText}}</span></Progress>
    </div>

  </section>
</template>

<script>
  import flightApi from '../request/flightApi';
  import baseTool from '../utils/baseFunction';
  import axios from 'axios';
  export default {
    name: 'UrgentNotice',
    data() {
      return {
        progress: 0,
        progressText: '',
        isMe: false,
      };
    },
    components: {},
    mounted() {
      // this.shopFriend();
      document.querySelector('body').setAttribute('style', 'background-color:#FFFFFF;overflow-y: scroll;height: auto;');
      this.shopFriend();
      this.getphoneType();

      if (this.$route.params.openid && this.$route.params.openid.length && this.$route.params.openid != 0) {

        flightApi.saveSearchFlightRecord1(this.$store.state.user.OpenId, this.$route.params.openid, 3, baseTool.formatterDate(new Date()), '疫情防控',this.phoneType).then(sucRes => {

          if (this.$route.params.openid != this.$store.state.user.OpenId) {} else {
            this.isMe = true;
            this.progressText = '已经有' + sucRes.data.Times + '个朋友查看！';
            this.progress = sucRes.data.Times;
          }

        });
      }


    },
    activated() {},
    methods: {
      getphoneType(){
        //获取userAgent信息
        var userAgentStr = navigator.userAgent;
        var iPhone = new RegExp("iPhone");
        var Android = new RegExp("Android");;
        if(iPhone.test(userAgentStr)){
          this.phoneType = "iPhone";
        }
        else if(Android.test(userAgentStr)){
          this.phoneType = userAgentStr.split('(Linux; Android ')[1].split('; ')[1].split(' Build')[0]
        }
      },
      shopFriend() {
        var that = this;
        wx.ready(function() { //需在用户可能点击分享按钮前就先调用
          wx.updateTimelineShareData({
            title: '疫情防控 | 6月9日起调整中山候机楼⇄广州机场班次！ ', // 分享标题
            link: 'http://www.callmefix.net/wechat/urgentnotice/' + that.$store.state.user.OpenId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://www.callmefix.net/img/notice.jpg', // 分享图标
            success: function() {
              // 设置成功
              flightApi.saveSearchFlightRecord1(this.$store.state.user.OpenId, this.$store.state.user.OpenId, 3, baseTool.formatterDate(new Date()), '疫情防控',this.phoneType).then(sucRes => {})
            }
          })
        });
      },
    },
  };
</script>

<style>
  .img {
    /* width: 96%;
    margin: 0 2%; */
    border: 1px solid #bfbfbf;
    margin-bottom: 10px;
  }

  .demand {
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
    margin-bottom: 10px;
    font-size: 15px;
    border-radius: 8px;
  }

  .infomation {
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
  }

  .appointment {
    width: 94%;
    margin: 10px 3% 0 3%;
    background: #2754bb;
    color: white;
    height: 40px;
    font-size: 18px;
    border: 0;
    border-radius: 10px;
    line-height: 10px;
    /* margin-bottom: 10px; */
  }

  input::-webkit-input-placeholder {
    color: #515A6E;
  }

  input::-moz-input-placeholder {
    color: #515A6E;
  }

  input::-ms-input-placeholder {
    color: #515A6E;
  }

  .top_recognition {
    /* margin: 0 0 10px 0; */
  }

  .recognition {
    text-align: center;
  }

  .ivu-progress .ivu-progress-outer {
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UrgentNotice.vue